var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcnBrush = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8125 1.59375C12.9375 1.71875 13 1.875 13 2.0625C13 2.25 12.9375 2.40625 12.8125 2.53125L6.84375 8.5L5 6.65625L10.9688 0.6875C11.0938 0.5625 11.25 0.5 11.4375 0.5C11.625 0.5 11.7812 0.5625 11.9062 0.6875L12.8125 1.59375ZM2.25 8.4375C2.64583 8.04167 3.11458 7.84375 3.65625 7.84375C4.19792 7.84375 4.66667 8.04167 5.0625 8.4375C5.45833 8.83333 5.65625 9.30208 5.65625 9.84375C5.65625 10.5729 5.39583 11.1979 4.875 11.7188C4.35417 12.2396 3.72917 12.5 3 12.5C1.91667 12.5 1.03125 12.0521 0.34375 11.1562C0.65625 11.1562 0.947917 11.0417 1.21875 10.8125C1.51042 10.5625 1.65625 10.2396 1.65625 9.84375C1.65625 9.30208 1.85417 8.83333 2.25 8.4375Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcnBrush, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icn-brush.a27cf929.svg";
export { ForwardRef as ReactComponent };